import { Field, ID, InputType } from 'type-graphql'
import type { IAction } from '../../action/IAction'
import { ActionArgs } from '../../action/ActionArgs'
import type { ReturnOrder } from '../ReturnOrder'

/**
 * Executes (or retries) a confirmed return's Pending/Failed refund legs against the gateway.
 */
@InputType()
export class ProcessReturnRefundArgs extends ActionArgs {
  @Field(() => ID)
  returnOrderId: string
}

export interface IProcessReturnRefund extends IAction<ReturnOrder, ProcessReturnRefundArgs> {}
